import styled from 'styled-components';
import { BLACK, WHITE, BG_GRAY, BORDER_GRAY } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

import IconClose from '../assets/close.svg';
import IconSwitch from '../assets/switch.svg';
import IconLogout from '../assets/logout.svg';
import IconSetting from '../assets/setting.svg';

export const DrawerBackground = styled.div`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  &.is-active {
    display: block;
  }
`;

export const Wrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  top: 0;
  right: 0;
  transition: all 0.3s ease 0s;
  transform: translateX(120%);
  z-index: 1002;
  background: ${WHITE};
  width: 300px;
  height: 100vh;
  box-shadow: -8px 0px 8px -1px rgba(0, 0, 0, 0.2);
  overflow-y: scroll;

  &.is-active {
    transform: translateX(0%);
  }

  ${media.tabletP`
    overflow-y: unset;
  `};
`;

export const Close = styled.div`
  cursor: pointer;
  width: 25px;
  height: 25px;
  background-image: url(${IconClose});
  background-repeat: no-repeat;
  margin: 6% 15px 10% auto;

  ${media.tabletP`
    margin: 45px 30px 40px auto;
  `};
`;

export const Menu = styled.div`
  ${media.tabletP`
    height: calc(100vh * 0.6);
  `};
`;

export const MenuList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  color: ${BLACK};
`;
export const MenuItem = styled.li`
  margin: 0 15px 25px;
  font-size: 18px;

  ${media.tabletP`
    margin: 0 30px 45px 30px;
  `};

  > a {
    text-decoration: none;

    &:link,
    &:focus,
    &:active,
    &:visited,
    &:hover {
      text-decoration: none;
    }
  }

  > a,
  > span {
    cursor: pointer;
  }
`;

export const ButtonSection = styled.div`
  margin: 0;
`;

export const Stylist = styled.div`
  height: 131px;
  background: ${BG_GRAY.COMMON_1};
  border-top: solid 1px ${BORDER_GRAY.COMMON_2};
  padding: 20px;

  .name {
    margin-bottom: 10px;
  }
  button {
    cursor: pointer;
    padding: 10px;
    background-color: ${BLACK};
    color: ${WHITE};
    font-size: 14px;
    background-image: url(${IconLogout});
    background-repeat: no-repeat;
    background-position: right 15px center;
    background-size: 14px 14px;
  }
`;
export const Config = styled.div`
  // closeボタン、4メニュー、「お客さま」切替ボタン、「ログアウト」ボタンの高さの合計を527pxとする
  min-height: calc(100vh - 527px);
  background: ${BG_GRAY.COMMON_1};
  border-top: solid 1px ${BORDER_GRAY.COMMON_2};
  padding: 20px;

  ${media.tabletP`
    height: 100%;
  `};

  .button {
    display: block;
    width: 100%;
    border: solid 1px ${BLACK};
    padding: 10px;
    text-align: center;
    color: ${BLACK};
    background-color: ${WHITE};
    background-image: url(${IconSetting});
    background-repeat: no-repeat;
    background-position: right 15px center;
    background-size: 20px 20px;
  }
`;

export const Button = styled.button`
  display: block;
  width: 100%;
  border: solid 1px ${BLACK};
  padding: 10px;
  font-size: 18px;
`;



// WEBPACK FOOTER //
// ./src/components/SalonConsultation/DrawerMenu/DrawerMenu.style.js